import { render, staticRenderFns } from "./ProfilesCards.vue?vue&type=template&id=690247cc&scoped=true&"
import script from "./ProfilesCards.vue?vue&type=script&lang=js&"
export * from "./ProfilesCards.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesCards.vue?vue&type=style&index=0&id=690247cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690247cc",
  null
  
)

export default component.exports